import { render, staticRenderFns } from "./userPact.vue?vue&type=template&id=0e066158&scoped=true"
import script from "./userPact.vue?vue&type=script&lang=js"
export * from "./userPact.vue?vue&type=script&lang=js"
import style0 from "./userPact.vue?vue&type=style&index=0&id=0e066158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e066158",
  null
  
)

export default component.exports